<template>
  <div
    :class="
      $vuetify.breakpoint.xsOnly
        ? 'px-0 py-2 animate__animated animate__fadeIn'
        : 'pa-4 animate__animated animate__fadeIn'
    "
  >
    <h2 class="title_tab mb-3">
      เจ้าหน้าที่
      <v-btn
        v-if="role_name == 'Super Admin'"
        :class="$vuetify.breakpoint.xsOnly ? 'float-right' : 'float-right mt-2'"
        color="button"
        dark
        small
        @click="openDialog('')"
      >
        <v-icon x-small class="mr-1">mdi-plus</v-icon>เพิ่มรายชื่อ
      </v-btn>
    </h2>
    <!-- <pre>{{all_staff_data}}</pre> -->
    <div>
      <v-data-table
        :headers="headers"
        :items="all_staff_data"
        hide-default-header
        :items-per-page="max_per_page"
        class="data_table_footer"
        :page.sync="page"
        @page-count="pageCount = $event"
      >
        <!-- <template v-slot:no-data>
          <div class="text-center pa-12">
            <p
              class="py-6"
              :style="$vuetify.breakpoint.xsOnly?'font-size:16px;':'font-size:22px;'"
            >ไม่มีข้อมูล</p>
          </div>
        </template>-->
        <template v-slot:top v-if="!$vuetify.breakpoint.xsOnly">
          <div class="pt-2" v-if="!$vuetify.breakpoint.xsOnly">
            <v-card
              flat
              style="border-radius: 10px"
              color="card_header"
              class="px-4 staff-header"
            >
              <v-row>
                <v-col
                  v-for="(item, index) in headers"
                  :key="index"
                  :cols="index == 0 || index == 5 ? 1 : 2"
                  :class="
                    index == 0
                      ? 'px-1 text-center'
                      : $vuetify.breakpoint.smOnly
                      ? 'px-1 '
                      : ''
                  "
                >
                  <span v-if="$vuetify.breakpoint.smOnly && index == 0"
                    >รหัส</span
                  >
                  <span v-else>{{ item.text }}</span>
                </v-col>
                <!-- :sm="index==2||index==3?3:(index==4?2:2)" -->
              </v-row>
            </v-card>
          </div>
        </template>
        <template v-slot:body="{ items }" v-if="all_staff_data != ''">
          <div v-if="!$vuetify.breakpoint.xsOnly">
            <v-card
              :loading="all_staff_data == ''"
              flat
              style="border-radius: 10px"
              color="card_body"
              v-for="(item, index) in items"
              :key="index"
              class="my-2 px-4 py-0 staff-text"
            >
              <v-row align="center" justify="center" class="font-kanit-bold">
                <v-col
                  :class="
                    $vuetify.breakpoint.smOnly
                      ? 'px-1 text-center'
                      : 'text-center'
                  "
                  cols="1"
                  >{{ item.staff_code == null ? "-" : item.staff_code }}</v-col
                >
                <v-col
                  :class="$vuetify.breakpoint.smOnly ? 'px-1' : ''"
                  cols="2"
                  >{{
                    (item.pname ? item.pname : "") +
                    (item.fname ? item.fname + " " : "") +
                    (item.lname ? item.lname : "")
                  }}</v-col
                >
                <v-col
                  :class="$vuetify.breakpoint.smOnly ? 'px-1' : ''"
                  cols="2"
                  >{{ item.email }}</v-col
                >

                <v-col
                  :class="$vuetify.breakpoint.smOnly ? 'px-1' : ''"
                  cols="2"
                  >{{ item.phone }}</v-col
                >
                <v-col
                  :class="$vuetify.breakpoint.smOnly ? 'px-1' : ''"
                  cols="2"
                  >{{ item.position == null ? "-" : item.position }}</v-col
                >
                <v-col
                  :class="$vuetify.breakpoint.smOnly ? 'px-1' : ''"
                  cols="1"
                  sm="1"
                  md="2"
                >
                  <v-icon
                    :x-small="!$vuetify.breakpoint.smOnly"
                    :small="$vuetify.breakpoint.smOnly"
                    :class="
                      $vuetify.breakpoint.smOnly ? 'mb-1 px-1' : 'mb-1 pr-1'
                    "
                    :color="item.status == true ? 'green' : ''"
                    >mdi-circle</v-icon
                  >

                  <span v-if="!$vuetify.breakpoint.smOnly">{{
                    item.status == true ? "พนักงานปกติ" : "พ้นสภาพ"
                  }}</span>
                </v-col>
                <v-col
                  :class="$vuetify.breakpoint.smOnly ? 'px-1' : ''"
                  cols="1"
                  sm="2"
                  md="1"
                >
                  <v-btn
                    class="float-right font-kanit-light"
                    outlined
                    x-small
                    style="background: white"
                    @click="openDialog(item)"
                    >รายละเอียด</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </div>
          <div class="pa-0" v-if="$vuetify.breakpoint.xsOnly">
            <v-card
              :loading="all_staff_data == ''"
              flat
              color="card_header"
              v-for="(item, index) in items"
              :key="index"
              class="my-2 px-4 py-0 pr-3"
            >
              <v-row align="center" justify="center" class="pa-0">
                <v-col cols="12" class="py-0">
                  <v-row class="py-0">
                    <v-col cols="5" class="location-xs-header py-0 pt-2"
                      >รหัสเจ้าหน้าที่</v-col
                    >
                    <v-col
                      cols="7"
                      style="background: #f2f2f2"
                      class="location-xs-text py-0 pt-2"
                      >{{
                        item.staff_code == null ? "-" : item.staff_code
                      }}</v-col
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="py-0">
                    <v-col cols="5" class="location-xs-header py-0 pt-1"
                      >ชื่อเจ้าหน้าที่</v-col
                    >
                    <v-col
                      cols="7"
                      style="background: #f2f2f2"
                      class="location-xs-text py-0 pt-1"
                      >{{
                        (item.pname ? item.pname : "") +
                        (item.fname ? item.fname + " " : "") +
                        (item.lname ? item.lname : "")
                      }}</v-col
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="py-0">
                    <v-col cols="5" class="location-xs-header py-0 pt-1"
                      >อีเมล</v-col
                    >
                    <v-col
                      cols="7"
                      style="background: #f2f2f2"
                      class="location-xs-text py-0 pt-1"
                      >{{ item.email }}</v-col
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="py-0">
                    <v-col cols="5" class="location-xs-header py-0 pt-1"
                      >เบอร์โทร</v-col
                    >
                    <v-col
                      cols="7"
                      style="background: #f2f2f2"
                      class="location-xs-text py-0 pt-1"
                      >{{ item.phone }}</v-col
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="py-0">
                    <v-col cols="5" class="location-xs-header py-0 pt-1"
                      >สถานะ</v-col
                    >
                    <v-col
                      cols="7"
                      style="background: #f2f2f2"
                      class="location-xs-text py-0 pt-1"
                    >
                      <v-icon
                        x-small
                        class="mb-1 pr-1"
                        :color="item.status == true ? 'green' : ''"
                        >mdi-circle</v-icon
                      >

                      <span v-if="!$vuetify.breakpoint.smOnly">{{
                        item.status == true ? "พนักงานปกติ" : "พ้นสภาพ"
                      }}</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-row class="py-0">
                    <v-col
                      cols="5"
                      class="location-xs-header py-0 pt-1 pb-2"
                    ></v-col>
                    <v-col
                      cols="7"
                      style="background: #f2f2f2"
                      class="location-xs-text py-0 pt-1 pb-2"
                    >
                      <v-btn
                        class="font-kanit-bold my-1"
                        outlined
                        block
                        small
                        style="background: white"
                        @click="openDialog(item)"
                        >รายละเอียด</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- <v-row align="center" justify="center">
          
          <v-col cols="4" class="location-xs-header">
            <v-col cols="12" class="py-0 location-xs-header">ชื่อสาขา</v-col>
            <v-col cols="12" class="py-0 location-xs-header">เวลาทำการ</v-col>
            <v-col cols="12" class="py-0 location-xs-header">หมายเลขโทรศัพท์</v-col>
          </v-col>
          <v-col cols="8" class="location-xs-header">
            <v-col cols="12" class="py-0 location-xs-text">{{item.name}}</v-col>
            <v-col cols="12" class="py-0 location-xs-text">{{item.period}}</v-col>
            <v-col cols="12" class="py-0 location-xs-text">{{item.tel}}</v-col>
            <v-col cols="12" class="py-0 location-xs-text">
              <v-btn
                class="font-kanit-bold my-1"
                outlined
                block
                small
                style="background:white"
              >รายละเอียด</v-btn>
            </v-col>
          </v-col>
              </v-row>-->
            </v-card>
          </div>
        </template>
      </v-data-table>
    </div>

    <!-- <div class="text-center">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" xs="12" sm="10" md="8" xl="8" lg="7">
            <v-container class="max-width">
              <v-pagination v-model="page" class="my-4" :length="pageCount"></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div> -->
    <DialogStaff ref="dialog" @getstaff="getData()" />
  </div>
</template>
<script>
import DialogStaff from "../dialogsetting/DialogStaff";
export default {
  components: { DialogStaff },
  data() {
    return {
      role_name: this.$session.get("role"),
      page: 1,
      length_page: 1,
      pageCount: 0,
      max_per_page: 10,
      header_token: { headers: { token: this.$session.get("token") } },
      // all_staff: [],
      // header_token: {
      //   headers: {
      //     token:
      //       "eyJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlRGV0YWlsIjp7ImlkIjoyMCwiY2xpZW50SWQiOiJGVzAxIiwic2VjcmV0S2V5IjoiaHYzb2hUWHNUem9hOXRHIiwicHMiOiJGcm9udGVuZCBXZWIiLCJzdGF0dXMiOjEsInNlcnZpY2VTdGF0dXMiOiJhY3RpdmUiLCJjcmVhdGVkQXQiOiIyMDIwLTA3LTIxVDEyOjAwOjE1LjY5NiIsInVwZGF0ZWRBdCI6IjIwMjAtMDctMTcgMTA6MDE6MjkuOTU3In19.kLekwYl-bj8KiYUD3vHA5YcvFsnkN1Zd9lPr3XjwjQg"
      //   }
      // },
      show_all_staff_data: [],
      headers: [
        {
          text: "รหัสเจ้าหน้าที่",
          sortable: false,
          value: "staff_id",
        },
        {
          text: "ชื่อเจ้าหน้าที่",
          sortable: false,
          value: "name",
        },
        {
          text: "อีเมล",
          sortable: false,
          value: "email",
        },
        {
          text: "เบอร์โทร",
          sortable: false,
          value: "tel",
        },
        {
          text: "ตำแหน่ง",
          sortable: false,
          value: "position",
        },
        {
          text: "สถานะ",
          sortable: false,
          value: "status",
        },
        {
          text: "",
          sortable: false,
          value: "action",
        },
      ],
      all_staff_data: [],
    };
  },
  watch: {
    // page(value) {
    //   if (this.all_staff_data != []) {
    //     let show_data_staff = [];
    //     this.show_all_staff_data = [];
    //     this.all_staff_data.forEach((element, index) => {
    //       if (
    //         index >= (value - 1) * this.max_per_page &&
    //         index < value * this.max_per_page
    //       ) {
    //         show_data_staff.push(element);
    //       }
    //     });
    //     this.show_all_staff_data = show_data_staff;
    //   }
    // },
  },
  mounted() {},
  created() {
    this.getData();
  },
  computed: {},
  methods: {
    getData() {
      let staff = [];
      let active_staff = [];
      let inactive_staff = [];
      this.all_staff_data = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/staff", this.header_token)
        .then((response) => {
          // console.log(response.data.result);
          staff = response.data.result;
          // let check_length = response.data.result.length;
          // this.length_page = check_length / this.max_per_page;
          // this.length_page = parseInt(this.length_page);

          // if (check_length % this.max_per_page != 0) {
          //   this.length_page += 1;
          // }
          if (response.data.result && response.data.status == "OK") {
            staff.forEach((element) => {
              if (element.status == true) {
                active_staff.push(element);
              } else {
                inactive_staff.push(element);
              }
            });

            this.all_staff_data = active_staff.concat(inactive_staff);

            //   let get_show_data_staff = [];
            //   this.show_all_staff_data = [];
            //   this.all_staff_data.forEach((element, index) => {
            //     if (index >= 0 * this.max_per_page && index < this.max_per_page) {
            //       get_show_data_staff.push(element);
            //     }
            //   });
            //   this.show_all_staff_data = get_show_data_staff;
          }
        });
    },
    openDialog(item) {
      this.$refs.dialog.open(item);
    },
  },
};
</script>
<style>
